if (!customElements.get('quick-add-custom')) {
  customElements.define(
    'quick-add-custom',
    class QuickAddCustom extends HTMLElement {
      constructor() {
        super();
        this.quantityInput = this.querySelector('quantity-input');
        this.hiddenQuantityInput = this.querySelector('.js-custom-quantity-input');

        if (this.quantityInput && this.hiddenQuantityInput) {
          // Sync quantity-input value to hidden form input on every change
          this.quantityInput.addEventListener('change', () => {
            const inputEl = this.quantityInput.querySelector('input');
            if (inputEl) {
              this.hiddenQuantityInput.value = inputEl.value;
            }
          });

          // Also sync on button clicks (plus/minus) via input event
          this.quantityInput.querySelectorAll('button').forEach((button) => {
            button.addEventListener('click', () => {
              // Small delay to let QuantityInput update the value first
              setTimeout(() => {
                const inputEl = this.quantityInput.querySelector('input');
                if (inputEl) {
                  this.hiddenQuantityInput.value = inputEl.value;
                }
              }, 10);
            });
          });

          // Initialize with current value
          const inputEl = this.quantityInput.querySelector('input');
          if (inputEl) {
            this.hiddenQuantityInput.value = inputEl.value;
          }
        }

        this.addEventListener('submit', (e) => {
          if (window.innerWidth >= 750) return;

          const quantitySelector = this.querySelector('.js-custom__quantity');
          if (quantitySelector && quantitySelector.classList.contains('small-hide')) {
            e.preventDefault();
            e.stopImmediatePropagation();
            quantitySelector.classList.remove('small-hide');
            return false;
          }
        }, true);

        this.addEventListener('click', (e) => {
          const mobileSubTrigger = e.target.closest('.js-mobile-subscription');
          if (mobileSubTrigger) {
            const subscriptionModal = document.querySelector('subscription-modal');
            if (subscriptionModal) {
              const productData = JSON.parse(mobileSubTrigger.dataset.productJson || '{}');
              
              const titleEl = subscriptionModal.querySelector('.js-subscription-modal-title');
              const priceEl = subscriptionModal.querySelector('.js-subscription-modal-price');
              const sellingPriceEl = subscriptionModal.querySelector('.js-subscription-modal-selling-price');
              const percentageEl = subscriptionModal.querySelector('.js-subscription-modal-percentage');
              const variantIdInput = subscriptionModal.querySelector('.js-subscription-modal-variant-id');
              const sellingPlanInput = subscriptionModal.querySelector('.js-subscription-modal-selling-plan-id');
              const plansContainer = subscriptionModal.querySelector('.js-subscription-modal-plans');
              const submitPriceEl = subscriptionModal.querySelector('.js-submit-price');

              if (titleEl) titleEl.textContent = productData.title;
              if (priceEl) priceEl.textContent = productData.price;
              if (percentageEl) percentageEl.textContent = productData.selling_percentage;
              if (variantIdInput) variantIdInput.value = productData.id;
              if (submitPriceEl) submitPriceEl.textContent = productData.price;
              
              if (sellingPlanInput) sellingPlanInput.value = '';

              if (plansContainer) {
                plansContainer.innerHTML = '';
                const loaderTemplate = subscriptionModal.querySelector('.js-subscription-loader-template');
                
                productData.selling_plans.forEach((plan, index) => {
                  const planDiv = document.createElement('div');
                  planDiv.className = 'js-subscritpion-widget widget-subscription';
                  const btn = document.createElement('button');
                  btn.type = 'button';
                  btn.className = 'quick-add__submit button button--full-width button--secondary js-subscription-modal-plan-item';
                  if (index === 0) btn.classList.add('active'); 
                  btn.dataset.planId = plan.id;
                  btn.dataset.planPrice = plan.price;
                  btn.innerHTML = `<span>${plan.name}</span>`;
                  if (loaderTemplate) {
                    const loader = loaderTemplate.firstElementChild.cloneNode(true);
                    btn.appendChild(loader);
                  }
                  planDiv.appendChild(btn);
                  plansContainer.appendChild(planDiv);
                  if (index === 0) {
                    if (sellingPlanInput) sellingPlanInput.value = plan.id;
                    if (sellingPriceEl) sellingPriceEl.textContent = plan.price;
                    if (submitPriceEl) submitPriceEl.textContent = plan.price;
                  }
                });
                plansContainer.querySelectorAll('.js-subscription-modal-plan-item').forEach(btn => {
                   btn.addEventListener('click', () => {
                      plansContainer.querySelectorAll('.js-subscription-modal-plan-item').forEach(b => b.classList.remove('active'));
                      btn.classList.add('active');
                      if (sellingPlanInput) sellingPlanInput.value = btn.dataset.planId;
                      if (sellingPriceEl) sellingPriceEl.textContent = btn.dataset.planPrice;
                      if (submitPriceEl) submitPriceEl.textContent = btn.dataset.planPrice;
                   });
                });
              }
              subscriptionModal.open();
            }
            return;
          }

          const subTrigger = e.target.closest('.js-subscription-button');
          if (subTrigger) {
            const subTriggerGroup = e.target.closest('.js-subscribe-button-groups');
            if(subTriggerGroup){
              subTriggerGroup.classList.add('append-widget');
            }
            this.querySelectorAll('.js-subscritpion-widget').forEach((box) => box.classList.remove('hidden'));
            return;
          }

          const subscriptionBtn = e.target.closest('.js-subscritpion-widget');
          if (subscriptionBtn && (subscriptionBtn.tagName === 'BUTTON' || subscriptionBtn.closest('button'))) {
            const form = this.querySelector('form');
            if (!form) return;

            const planId = subscriptionBtn.dataset.planId || subscriptionBtn.closest('button')?.dataset.planId;
            const sellingPlanInput = form.querySelector('input[name="selling_plan"]');
            if (sellingPlanInput) sellingPlanInput.value = planId;

            // Loading state
            subscriptionBtn.setAttribute('aria-disabled', true);
            subscriptionBtn.classList.add('loading');
            const loader = subscriptionBtn.querySelector('.js-subscription-loader');
            if (loader) loader.classList.remove('hidden');

            form.setAttribute('data-skip-loader', 'true');

            // Trigger submit
            const submitBtn = form.querySelector('[name="add"]');
            if (submitBtn) {
              submitBtn.click();

              setTimeout(() => {
                subscriptionBtn.removeAttribute('aria-disabled');
                subscriptionBtn.classList.remove('loading');
                if (loader) loader.classList.add('hidden');
                form.removeAttribute('data-skip-loader');
              }, 1000);
            }
          }
        });
      }
    }
  );
}

if (!customElements.get('subscription-modal')) {
  customElements.define(
    'subscription-modal',
    class SubscriptionModal extends HTMLElement {
      constructor() {
        super();
        this.overlay = document.querySelector('.js-subscribtion-modal-overlay');

        this.addEventListener('click', (e) => {
          if (e.target.closest('.js-subscription-modal-close')) {
            this.close();
          }
        });

        if (this.overlay) {
          this.overlay.addEventListener('click', () => {
             this.close();
          });
        }

        if (window.subscribe) {
          subscribe('cart-update', () => {
            if (!this.classList.contains('hidden')) {
              this.close();
            }
          });
        }
      }

      open() {
        this.classList.remove('hidden');
        if (this.overlay) this.overlay.classList.add('active');
        document.body.classList.add('overflow-hidden');
      }

      close() {
        this.classList.add('hidden');
        if (this.overlay) this.overlay.classList.remove('active');
        document.body.classList.remove('overflow-hidden');
      }
    }
  );
}